<template>
    <div class="content-box">
         <div class="content content2">
             <div class="title-box">
                 <div class="title">
                     <div class="title-text">预选合作方案</div>
                     <div class="title-e">PRE-SELECT COOPERATION PLANS</div>
                     <div class="title-line"></div>
                 </div>
             </div>
             <div class="describe-characteristic3" style="margin-top: 20px;">
                 <div class="question">您想在哪座城市投资充电场？</div>
                 <div class="question-item">
                   <treeselect
                     v-model="value"
                     placeholder="请选择加盟城市"
                     :options="area"
                     :class="{ 'border-color': !!value }"
                     :disable-branch-nodes="true"
                     :clearable="false"
                     :load-options="handleItemChange"
                     style="width: 400px"
                     @open="$emit('selectOpenStatus', true)"
                     @close="$emit('selectOpenStatus')"
                   />
                 </div>
             </div>
             <div class="describe-characteristic3">
                 <div class="question">您想投资多大面积的充电场？</div>
                 <div class="question-item">
                    <div class="question-option" :class="{'select-option':mj===200}" @click="mj=200,tzData.addArea='600㎡以下'">600㎡以下<span></span></div>
                    <div class="question-option" :class="{'select-option':mj===300}" @click="mj=300,tzData.addArea='600㎡-10000㎡'">600㎡-10000㎡<span></span></div>
                    <div class="question-option" :class="{'select-option':mj===380}" @click="mj=380,tzData.addArea='10000㎡-15000㎡'">10000㎡-15000㎡<span></span></div>
                    <div class="question-option" :class="{'select-option':mj===420}" @click="mj=420,tzData.addArea='15000㎡以上'">15000㎡以上<span></span></div>
                 </div>
             </div>
             <div class="describe-characteristic3">
                 <div class="question">您想在充电场使用多大规格的充电桩？</div>
                 <div class="question-item">
                    <div class="question-option" :class="{'select-option':gm===1}" @click="gm=1,tzData.addCharging='60kw以下'">60kw以下<span></span></div>
                     <div class="question-option" :class="{'select-option':gm===2}" @click="gm=2,tzData.addCharging='60-90kw'">60-90kw<span></span></div>
                     <div class="question-option" :class="{'select-option':gm===3}" @click="gm=3,tzData.addCharging='90-120kw'">90-120kw<span></span></div>
                     <div class="question-option" :class="{'select-option':gm===4}" @click="gm=4,tzData.addCharging='120kw以上'">120kw以上<span></span></div>
                 </div>
             </div>
             <div class="describe-characteristic3">
                 <div class="question">您想采用哪种合作模式？</div>
                 <div class="question-item">
                    <div class="question-option" :class="{'select-option':hzms==='a'}" @click="hzms='a'">建站方案策划<span></span></div>
                    <div class="question-option" :class="{'select-option':hzms==='b'}" @click="hzms='b'">建站方案策划+场站建设实施<span></span></div>
                    <div class="question-option" :class="{'select-option':hzms==='c'}" @click="hzms='c'">建站方案策划+场站建设实施+场站委托运营<span></span></div>
                 </div>
             </div>
<!--             <div class="describe-characteristic3" style="margin-top: 18px">-->
<!--                 预估所需投资总费用：<span class="num">{{result}}</span><span style="color:rgba(230,46,16,1);">元</span>-->
<!--             </div>-->
             <div class="describe-characteristic3">
                想了解更详细、精准的合作方案以及费用, 可在下方信息框内留下您的联系方式. 我们将派专业人士为您详细解答。
             </div>
         </div>
    </div>

</template>

<script>
import Axios from "axios";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: { Treeselect },
  data() {
    return {
      value: "510100",
      area: [],
        isCity:true,
        mj:200,
        gm:1,
		hzms:'a',
	}
  },
  props:{
	tzData:null
  },
computed:{
    result(){
    	this.tzData.addCity = this.isCity?'成都':'郑州'
        if(this.hzms === 'a'){
        	this.tzData.addCooperationMode = '建站方案策划'
			return this.tzData.addEstimatedCost ='50000.00'
        }else if(this.hzms === 'b'){
			this.tzData.addCooperationMode = '建站方案策划+场站建设实施'
        	if(this.mj===200){
        		if(this.gm===1)return this.tzData.addEstimatedCost ='1400000.00'
                else if(this.gm===2)return this.tzData.addEstimatedCost ='1500000.00'
                else if(this.gm===3)return this.tzData.addEstimatedCost ='1700000.00'
                else if(this.gm===4)return this.tzData.addEstimatedCost ='2000000.00'
            }else if(this.mj===300){
                if(this.gm===1)return this.tzData.addEstimatedCost ='1700000.00'
                else if(this.gm===2)return this.tzData.addEstimatedCost ='1900000.00'
                else if(this.gm===3)return this.tzData.addEstimatedCost ='2100000.00'
                else if(this.gm===4)return this.tzData.addEstimatedCost ='2400000.00'
			}else if(this.mj===380){
                if(this.gm===1)return this.tzData.addEstimatedCost ='2000000.00'
                else if(this.gm===2)return this.tzData.addEstimatedCost ='2200000.00'
                else if(this.gm===3)return this.tzData.addEstimatedCost ='2400000.00'
                else if(this.gm===4)return this.tzData.addEstimatedCost ='2700000.00'
            }else if(this.mj===420){
                if(this.gm===1)return this.tzData.addEstimatedCost ='2300000.00'
                else if(this.gm===2)return this.tzData.addEstimatedCost ='2500000.00'
                else if(this.gm===3)return this.tzData.addEstimatedCost ='2700000.00'
                else if(this.gm===4)return this.tzData.addEstimatedCost ='3000000.00'
            }
        }else{
			this.tzData.addCooperationMode = '建站方案策划+场站建设实施+场站委托运营'
            if(this.mj===200){
                if(this.gm===1)return this.tzData.addEstimatedCost ='1600000.00'
                else if(this.gm===2)return this.tzData.addEstimatedCost ='1700000.00'
                else if(this.gm===3)return this.tzData.addEstimatedCost ='1900000.00'
                else if(this.gm===4)return this.tzData.addEstimatedCost ='2200000.00'
            }else if(this.mj===300){
                if(this.gm===1)return this.tzData.addEstimatedCost ='2000000.00'
                else if(this.gm===2)return this.tzData.addEstimatedCost ='2200000.00'
                else if(this.gm===3)return this.tzData.addEstimatedCost ='2400000.00'
                else if(this.gm===4)return this.tzData.addEstimatedCost ='2700000.00'
            }else if(this.mj===380){
                if(this.gm===1)return this.tzData.addEstimatedCost ='2380000.00'
                else if(this.gm===2)return this.tzData.addEstimatedCost ='2580000.00'
                else if(this.gm===3)return this.tzData.addEstimatedCost ='2780000.00'
                else if(this.gm===4)return this.tzData.addEstimatedCost ='3080000.00'
            }else if(this.mj===420){
                if(this.gm===1)return this.tzData.addEstimatedCost ='2720000.00'
                else if(this.gm===2)return this.tzData.addEstimatedCost ='2920000.00'
                else if(this.gm===3)return this.tzData.addEstimatedCost ='3120000.00'
                else if(this.gm===4)return this.tzData.addEstimatedCost ='3420000.00'
            }
        }
    }
},
  methods: {
    getData() {
      Axios.post(
        "https://www.aostarit.com.cn/icity-mgrserver/station/primary/infos"
      )
        .then((res) => {
          let data = res.data;
          if (data.success) {
            data.data.map((item) => {
              if (
                item.areaId === "820000" ||
                item.areaId === "810000" ||
                item.areaId === "710000"
              ) {
                this.area.push({
                  id: item.areaId,
                  label: item.areaName,
                });
              } else if (item.areaId === "510000") {
                this.handleItemChangeInit({
                  id: item.areaId,
                  label: item.areaName,
                  children: [],
                });
              } else {
                this.area.push({
                  id: item.areaId,
                  label: item.areaName,
                  children: null,
                });
              }
            });
          }
        })
        .catch();
    },
    handleItemChange({ action, parentNode, callback }) {
      let me = this;
      let areaId = parentNode.id;
      Axios.post(
        "https://www.aostarit.com.cn/icity-mgrserver/station/subordinate/infos?areaId=" +
        areaId
      )
        .then((res) => {
          let data = res.data;
          if (data.success) {
            me.area.map((item) => {
              if (item.id === areaId) {
                item.children = data.data.map((vv) => {
                  return {
                    id: vv.areaId,
                    label: vv.areaName,
                  };
                });
              }
            });
            callback();
          }
        })
        .catch();
    },
    handleItemChangeInit(row) {
      let me = this;
      let areaId = 510000;
      Axios.post(
        "https://www.aostarit.com.cn/icity-mgrserver/station/subordinate/infos?areaId=" +
        areaId
      )
        .then((res) => {
          let data = res.data;
          if (data.success) {
            row.children = data.data.map((vv) => {
              return {
                id: vv.areaId,
                label: vv.areaName,
              };
            });
            me.area.push(row);
          }
        })
        .catch();
    },
  },
  mounted() {
    this.getData();
  },
}
</script>
<style src="./i_public.less" lang="less" scoped></style>
<!--<style lang="less" scoped>-->
    <!--.content-box{-->
        <!--width: 100%;-->
        <!--margin: 0px auto;-->
        <!--height: 100%;-->
        <!--background-color: #fbfbfb;-->
        <!--font-family:PingFangSC-Regular,PingFang SC;-->
        <!--.content{-->
            <!--width: 1200px;-->
            <!--height: 600px;-->
            <!--margin: 0px auto;-->
            <!--padding:20px;-->
            <!--position: relative;-->
            <!--.title-box{-->
                <!--display: flex;-->
                <!--justify-content: space-between;-->
                <!--font-size: 20px;-->
                <!--width: 1000px;-->
                <!--margin: 2% auto;-->
                <!--height: 66px;-->
                <!--text-align: left;-->
                <!--.title-text {-->
                    <!--color: #05123E;-->
                    <!--font-size: 30px;-->
                    <!--font-weight: 500;-->
                <!--}-->
                <!--.title-e {-->
                    <!--font-size: 10px;-->
                    <!--color: #6684D0;-->
                    <!--line-height: 30px;-->
                    <!--letter-spacing: 1px;-->
                <!--}-->
                <!--.title-line {-->
                    <!--background: linear-gradient(90deg,  #099AFF, #3AFEFE);-->
                    <!--height: 2px;-->
                    <!--width: 30px;-->
                    <!--margin: 0 auto;-->
                    <!--border-radius: 1px;-->
                    <!--margin-left: 0;-->
                <!--}-->
                <!--.end-rukou{-->
                    <!--font-size: 14px;-->
                    <!--color: #19C1E7;-->
                    <!--text-align: right;-->
                    <!--line-height: 66px;-->
                    <!--.icon-img{-->
                        <!--background-image: url('./../../../assets/icon_next 2@2x.png');-->
                        <!--display: inline-block;-->
                        <!--width: 24px;-->
                        <!--height: 24px;-->
                        <!--background-repeat: no-repeat;-->
                        <!--background-size: 24px 24px;-->
                        <!--margin-bottom: -6px;-->
                    <!--}-->
                <!--}-->
            <!--}-->
            <!--.describe{-->
                <!--width: 1000px;-->
                <!--margin: 0 auto;-->
                <!--text-align: left;-->
                <!--color: #526BAB;-->
                <!--font-size: 16px;-->
                <!--line-height: 30px;-->
            <!--}-->
            .describe-characteristic{
                width: 1000px;
                margin: 6px auto;
                text-align: left;
                color: #1A3068;
                font-size: 12px;
                line-height: 28px;
                .question-item{
                    display: flex;
                    flex-flow: row;
                    .question-option{
                        cursor: default;
                        padding:0px 50px 0 20px;
                        border-radius:4px;
                        border:1px solid rgba(26,48,104,1);
                        margin-right: 10px;
                        position: relative;
                        font-size: 12px;
                        line-height: 24px;
                        span{
                            width: 16px;
                            height: 16px;
                            line-height: 16px;
                            border-radius:10px;
                            text-align: center;
                            color: #fff;
                            position: absolute;
                            right: 8px;
                            top: 4px;
                            background-color: #27D6FF;
                            display: none;
                        }
                    }
                    .select-option{
                        background:rgba(231,246,254,1);
                        border-radius:4px;
                        border:1px solid rgba(39,214,255,1);
                        color:rgba(39,214,255,1);
                        span{
                            display: inline-block;
                        }
                    }
                }
                .num{
                    font-size: 26px;
                    color:rgba(230,46,16,1);
                }
            }
        <!--}-->
    <!--}-->

    <!--@media screen and (max-width: 1100px) {-->
    <!--}-->
    <!--@media screen and (max-width: 1000px) {-->
    <!--}-->
    <!--@media screen and (max-width: 800px) {-->
    <!--}-->

<!--</style>-->